import React from "react";
import { Route, Switch } from "react-router-dom";
// No logged
import App from "../App";
import LoginPage from "../screens/LoginScreen";
import ResetPasswordPage from "../screens/ResetPasswordPage";
// ACCOUNT
import Settings from "../screens/settings/Show";
// SIDEBAR
import Sidebar from "Components/sidebar/Sidebar";
// DOMAIN
import DomainShow from "../screens/domains/Show";
// EMAIL ACCOUNTS
import EmailAccountNew from "../screens/emailAccounts/New";
import EmailAccount from "../screens/emailAccounts/Show";
import EmailAccountsList from "../screens/emailAccounts/List";
import EmailAccountSettings from "../screens/emailAccounts/Settings";
// ALIAS DOMAINS
import AliasDomainsList from "../screens/aliasDomains/List";
import AliasDomainsNew from "../screens/aliasDomains/New";
// ALIAS EMAIL ACCOUNTS
import AliasEmailAccountsList from "../screens/aliasEmailAccounts/List";
import AliasEmailAccountsNew from "../screens/aliasEmailAccounts/New";
// AUDITS
import AuditsList from "../screens/audits/List";
// DASHBOARD
import DashboardPage from "../screens/dashboard/Dashboard";
// CUSTOMIZATIONS
// import CustomizationsPage from '../containers/customizations/index.jsx'
// ETLIVE
import ETLive from "../screens/etlive/List";
// import MainCustomizationAdd from '../containers/customizations/AddMain'
// IMPORTS
import ImportsList from "../screens/imports/List";
import ImportsAdd from "../screens/imports/New";
import ImportResourcesList from "../screens/imports/Resources";
// MIGRATIONS
import MigrationsList from "../screens/migrations/List";
import MigrationsAdd from "../screens/migrations/New";
import MigrationResourcesList from "../screens/migrations/Resources";
// OTHERS
import ServerMissing from "Components/ServerMissing";
import NotFound from "Components/NotFound";
import qs from "query-string";

export default (props) => (
  <div>
    <Route path="manteinance" component={ServerMissing} />
    <Route path="login" component={LoginPage} />
    <Route path="users/:userCode/reset_password" component={ResetPasswordPage} />

    <Route
      render={(routerProps) => {
        const p = { ...props, ...routerProps };
        // add location.query to the props
        p.location.query = qs.parse(p.location.search);

        return (
          <Sidebar {...p}>
            <Switch>
              <Route exact path="/audits" component={AuditsList} />
              <Route exact path="/account" component={Settings} />
              <Route exact path="/tracemail" component={ETLive} />
              <Route exact path="/dashboard" component={DashboardPage} />

              {p.loggedUser.is_vianova && <Route exact path="/imports" component={ImportsList} />}
              {p.loggedUser.is_vianova && (
                <Route exact path="/imports/:importCode/resources" component={ImportResourcesList} />
              )}
              {p.loggedUser.is_vianova && <Route exact path="/imports/add" component={ImportsAdd} />}

              {p.loggedUser.is_vianova && <Route exact path="/migrations" component={MigrationsList} />}
              {p.loggedUser.is_vianova && <Route exact path="/migrations/add" component={MigrationsAdd} />}
              {p.loggedUser.is_vianova && (
                <Route exact path="/migrations/:migrationCode/resources" component={MigrationResourcesList} />
              )}

              <Route
                path="/email_account/:emailCode"
                render={(props) => {
                  return (
                    <EmailAccount
                      {...{ ...p, ...props }}
                      render={(componentProps) => {
                        return (
                          <Route
                            exact
                            path="/email_account/:emailCode/settings"
                            render={() => <EmailAccountSettings {...{ ...p, ...componentProps }} />}
                          />
                        );
                      }}
                    />
                  );
                }}
              />

              <Route
                path="/"
                render={(props) => {
                  const subProps = { ...p, ...props };

                  return (
                    <DomainShow {...subProps}>
                      <Switch>
                        <Route exact path="/" render={() => <EmailAccountsList {...p} />} />
                        <Route exact path="/add" render={() => <EmailAccountNew {...p} />} />
                        <Route exact path="/aliases" render={() => <AliasDomainsList {...p} />} />
                        <Route exact path="/aliases/add" render={() => <AliasDomainsNew {...p} />} />
                        <Route exact path="/alias_email_accounts" render={() => <AliasEmailAccountsList {...p} />} />
                        <Route exact path="/alias_email_accounts/add" render={() => <AliasEmailAccountsNew {...p} />} />
                        <Route exact path="*" component={NotFound} />
                      </Switch>
                    </DomainShow>
                  );
                }}
              />

              <Route exact path="*" component={NotFound} />
            </Switch>
          </Sidebar>
        );
      }}
    />
  </div>
);
